import majorArcana from "./RW-DECK/Major_Arcana";
import minorArcana from "./RW-DECK/Minor_Arcana";

import plus from "./Plus.png";
import plusDark from "./Plus_Dark.png";
import book from './Book.png';
import bookDark from './Book_Dark.png';
import cardBack from './Card_Back.png';
import cardBackDark from './Card_Back_Dark.png';
import down from './down.png';

export const deckImages = [...majorArcana, ...minorArcana];

export const utilImages = {
    plus,
    plusDark,
    book,
    bookDark,
    cardBack,
    cardBackDark,
    down
}